export default __webpack_public_path__ + "static/media/Gloves of the Outer Dark.1a892c03.jpg";